import { IProductionDashboardBayVehicle } from "../models/ProductionDashboard";

/**
 * Whether a vehicle has finished the station it is sitting on and is only waiting to be moved on.
 *
 * "Finished" is every part in the current assembly actioned - removed, missing or damaged all
 * count as done, which is what the API's parts-removed count already reflects - with the assembly
 * timer stopped. A running timer means someone is still working it, however many parts are ticked.
 *
 * A vehicle that has finished its last assembly is done rather than waiting: it drops out of the
 * lanes into Completed Today, so it is excluded here.
 */
export const isAwaitingNextStation = (
  vehicle: Pick<
    IProductionDashboardBayVehicle,
    | "percentComplete"
    | "currentAssemblyPartsRemoved"
    | "currentAssemblyPartsTotal"
    | "currentAssemblyStartedOn"
  >
): boolean =>
  vehicle.percentComplete < 100 &&
  vehicle.currentAssemblyPartsTotal > 0 &&
  vehicle.currentAssemblyPartsRemoved >= vehicle.currentAssemblyPartsTotal &&
  !vehicle.currentAssemblyStartedOn;
